import React, { useRef, useState } from 'react'
import ImageLoader from './ImageLoader'
import Icon from '../Icon'
import { createPortal } from 'react-dom'
import ImageInfoModal from './ImageInfoModal'
import './ImageItem.scss'

const getBase64Image = (img) => {
  const canvas = document.createElement('canvas')
  canvas.width = img.naturalWidth
  canvas.height = img.naturalHeight
  const ctx = canvas.getContext('2d')
  ctx.drawImage(img, 0, 0)
  return canvas.toDataURL()
}

class CachedAssets {
  constructor () {
    this.cache = {}
  }

  get (item) {
    return this.cache[item.AssetID]
  }

  set (item, imageData) {
    this.cache[item.AssetID] = imageData
  }
}

const cachedAssets = new CachedAssets()

const ImageItem = ({ item, onDelete, onSelect, t, scrollableRef, validation, uiSchema, value, setClearUpload, defaultAssets }) => {
  const [showMenu, setShowMenu] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const iconMenuRef = useRef(null)

  const onImageLoad = (e) => {
    const cached = cachedAssets.get(item)
    if (!cached) {
      cachedAssets.set(item, getBase64Image(e.target))
    }
    setShowMenu(true)
  }
  const onMenuClick = (e) => {
    e.stopPropagation()
    setShowInfo(true)
  }
  const onMenuClose = (e) => {
    e?.stopPropagation()
    setShowInfo(false)
  }

  const onDeleteClick = () => {
    setShowInfo(false)
    onDelete(item)
  }

  const onSelectClick = (updatedItem) => {
    setClearUpload((state) => state + 1)
    setShowInfo(false)
    onSelect(updatedItem)
  }

  const thumbnailUrl = cachedAssets.get(item) || item.ThumbnailUrl

  return <div className="xmp-gs-sm-li-container" onClick={() => onSelectClick(item)}>
    <div className={`xmp-gs-sm-li  ${item.AssetID === value ? 'xmp-gs-sm-li-selected': ''}`}>
      {showMenu && <div className="xmp-gs-li-menu" ref={iconMenuRef} onClick={onMenuClick}>
        <Icon name="menu.svg" width="16px" height="16px"/>
      </div>}
      <ImageLoader {...{ className: 'image', src: thumbnailUrl, scrollableRef, onImageLoad }} />
    </div>
    <div className="xmp-gs-sm-li-name">{item.DisplayName}</div>
    {showInfo &&
      createPortal(
        <ImageInfoModal {...{
          item, t, iconRef: iconMenuRef, validation, uiSchema,
          onClose: onMenuClose, onDelete: onDeleteClick, onSelect: onSelectClick, defaultAssets
        }}/>,
        document.body)}
  </div>
}

export default ImageItem
